import axios from 'axios';
import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    DASHBOARD_SCAN_FAIL, // Renamed action type
    DASHBOARD_SCAN_REQUEST, // Renamed action type
    DASHBOARD_SCAN_SUCCESS, // Renamed action type
    DASHBOARD_RESET,
    CLEAR_ERRORS,
    FORGET_REQUEST,
    FORGET_SUCCESS,
    FORGET_FAIL,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL,
    VERIFY_OTP_REQUEST,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAIL,
    RESEND_OTP_REQUEST,
    RESEND_OTP_SUCCESS,
    RESEND_OTP_FAIL,
    OTP_VERIFICATION_RESET
} from '../constant/userConstant';
import { clearAllStorage } from '../../utils/clearStorage';

axios.defaults.withCredentials = true;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Login User
export const login = (username, password) => async (dispatch) => {
    try {
        dispatch({ type: LOGIN_REQUEST });

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const { data } = await axios.post(
            `${BASE_URL}/api/v1/auth/login`,
            { username, password },
            config
        );

        if (data.success) {
            // Store token in localStorage
            localStorage.setItem('token', data.data);

            // Set default authorization header for future requests
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.data}`;

            dispatch({
                type: LOGIN_SUCCESS,
                payload: {
                    username,
                    token: data.data
                }
            });
        } else {
            dispatch({
                type: LOGIN_FAIL,
                payload: data.message || 'Login failed'
            });
        }
    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
            payload: error.response?.data?.message || 'Login failed'
        });
    }
};

// Logout user
export const logout = () => async (dispatch) => {
    try {
        dispatch({ type: LOGOUT_REQUEST });

        // Get token from localStorage
        const token = localStorage.getItem('token');

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };

        // Make the logout API call
        await axios.post(`${BASE_URL}/api/v1/auth/logout`, {}, config);

        // Clear all localStorage data including preferences
        clearAllStorage();

        // Clear axios default header
        delete axios.defaults.headers.common['Authorization'];

        dispatch({ type: LOGOUT_SUCCESS });
        
        // Returning true to indicate successful logout
        return true;

    } catch (error) {
        dispatch({
            type: LOGOUT_FAIL,
            payload: error.response?.data?.message || 'Logout failed'
        });

        // Still remove token and all user data on error, as we want to log out the user locally
        clearAllStorage();
        delete axios.defaults.headers.common['Authorization'];
        
        // Force logout success even after API failure
        dispatch({ type: LOGOUT_SUCCESS });
        return true;
    }
};

// Get all scan data for the dashboard
export const dashboardScan = (page, params) => async (dispatch) => {
    try {
        dispatch({ type: DASHBOARD_SCAN_REQUEST });
        const token = localStorage.getItem('token');

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };


        if (params !== '' && params !== undefined) {
            const { data } = await axios.get(
                `${BASE_URL}/api/v1/admin/scan/${page}?${params}`,
                config,
            );

            dispatch({
                type: DASHBOARD_SCAN_SUCCESS,
                payload: data
            });
        } else {

            const { data } = await axios.get(
                `${BASE_URL}/api/v1/admin/scan/${page}`,
                config,
            );

            dispatch({
                type: DASHBOARD_SCAN_SUCCESS,
                payload: data
            });
        }
    } catch (error) {
        dispatch({
            type: DASHBOARD_SCAN_FAIL,
            payload: error.response
        });
        console.log("error", error.response);

    }
};

export const resetPassword = (email) => async (dispatch) => {
    try {
        dispatch({ type: FORGET_REQUEST });

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const { data } = await axios.post(
            `${BASE_URL}/api/v1/auth/reset-mail`,
            { email },
            config
        );

        if (data.success) {
            dispatch({
                type: FORGET_SUCCESS,
                payload: 'Reset link sent successfully'
            });
        } else {
            dispatch({
                type: FORGET_FAIL,
                payload: data.message || 'Reset request failed'
            });
        }
    } catch (error) {
        dispatch({
            type: FORGET_FAIL,
            payload: error.response?.data?.message || 'Reset request failed'
        });
    }
};

export const validateToken = (token) => async (dispatch) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/api/v1/auth/validate-token?q=${token}`);
        return data.success;
    } catch (error) {
        return false;
    }
};

export const changePassword = (token, password) => async (dispatch) => {
    try {
        dispatch({ type: CHANGE_PASSWORD_REQUEST });

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const { data } = await axios.post(
            `${BASE_URL}/api/v1/auth/change-password`,
            { token, password },
            config
        );

        if (data.success) {
            dispatch({
                type: CHANGE_PASSWORD_SUCCESS,
                payload: 'Password changed successfully'
            });
        } else {
            dispatch({
                type: CHANGE_PASSWORD_FAIL,
                payload: data.message || 'Password change failed'
            });
        }
    } catch (error) {
        dispatch({
            type: CHANGE_PASSWORD_FAIL,
            payload: error.response?.data?.message || 'Password change failed'
        });
    }
};

// Verify OTP
export const verifyOtp = (otp) => async (dispatch) => {
    try {
        dispatch({ type: VERIFY_OTP_REQUEST });
        
        const token = localStorage.getItem('token');
        
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };

        const { data } = await axios.post(
            `${BASE_URL}/api/v1/otp/verify-otp`,
            { otp },
            config
        );

        if (data.success) {
            localStorage.setItem('token', data.data);

            // Set default authorization header for future requests
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.data}`;

            dispatch({
                type: VERIFY_OTP_SUCCESS,
                payload: 'OTP verified successfully'
            });
            return true;
        } else {
            dispatch({
                type: VERIFY_OTP_FAIL,
                payload: data.message || 'OTP verification failed'
            });
            return false;
        }
    } catch (error) {
        dispatch({
            type: VERIFY_OTP_FAIL,
            payload: error.response?.data?.message || 'OTP verification failed'
        });
        return false;
    }
};

// Resend OTP
export const resendOtp = () => async (dispatch) => {
    try {
        dispatch({ type: RESEND_OTP_REQUEST });
        
        const token = localStorage.getItem('token');
        
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };

        const { data } = await axios.get(
            `${BASE_URL}/api/v1/otp/resend-otp`,
            config
        );

        if (data.success) {
            dispatch({
                type: RESEND_OTP_SUCCESS,
                payload: 'OTP resent successfully'
            });
        } else {
            dispatch({
                type: RESEND_OTP_FAIL,
                payload: data.message || 'OTP resend failed'
            });
        }
    } catch (error) {
        dispatch({
            type: RESEND_OTP_FAIL,
            payload: error.response?.data?.message || 'OTP resend failed'
        });
    }
};

// Reset dashboard state
export const resetDashboard = () => async (dispatch) => {
    dispatch({ type: DASHBOARD_RESET });
};

// Reset OTP verification state
export const resetOtpVerification = () => async (dispatch) => {
    dispatch({ type: OTP_VERIFICATION_RESET });
};

// Clear Errors
export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS
    });
};
